// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 8: परमप्रधान की सहायता (बोनस)
// ============================================================================
// स्तर 92 (1 बोनस स्तर, 3 प्रश्न)

export const chapter8Translations = {
  name: "परमप्रधान की सहायता",
  description: "जो परमप्रधान के छत्र-छाया में रहता है, वह सर्वशक्तिमान की छाया तले बसा रहता है",
  
  spiritualWisdom: {
    principle: "आप पर्वत के शिखर पर पहुँच चुके हैं, और ज्ञान प्राप्त हो चुका है",
    scripture: "जो परमप्रधान के छत्र-छाया में रहता है, वह सर्वशक्तिमान की छाया तले बसा रहता है (भजन संहिता 91:1)",
    application: "अटल विश्वास के लिए जीवन का अनुभव, दया और यीशु का सच्चा प्रेम आवश्यक है। परीक्षाएं आपके हृदय की, चुने गए सच्चे मार्ग की परीक्षा लेंगी।"
  },
  
  levels: {
    92: {
      name: "परमप्रधान का छत्र-छाया",
      challenge: "आप पर्वत के शिखर पर हैं... लेकिन अटल विश्वास अब शुरू होता है...",
      easy: {
        question: "यीशु व्यक्तिगत रूप से आपके लिए कौन हैं?",
        options: [
          "एक साधारण भविष्यवक्ता",
          "मेरे व्यक्तिगत प्रभु और उद्धारकर्ता",
          "एक किंवदंती",
          "एक दार्शनिक"
        ],
        hint: "वह वही हैं जो हमें बचाने के लिए अपना जीवन देते हैं",
        funFact: "✝️ यीशु परमेश्वर हैं! वह केवल एक ऐतिहासिक व्यक्तित्व नहीं हैं - वह जीवित हैं और हम में से प्रत्येक के साथ व्यक्तिगत संबंध चाहते हैं!"
      },
      medium: {
        question: "दानिय्येल की तरह उपवास करना हमें परमेश्वर को बेहतर ढंग से सुनने में क्यों मदद करता है?",
        options: [
          "वजन कम करने के लिए",
          "खुद को उससे वंचित करने के लिए जिसे हम प्यार करते हैं और एक परिवर्तित हृदय पाने के लिए",
          "दूसरों को प्रभावित करने के लिए",
          "और मजबूत होने के लिए"
        ],
        hint: "अपने आप को उससे वंचित करें जिसे आप सबसे ज्यादा प्यार करते हैं, शांति और ज्ञान में",
        funFact: "🙏 आध्यात्मिक उपवास हमारे हृदय को गहरे परिवर्तनों के लिए तैयार करता है - अक्सर दर्दनाक - जो हमें परमेश्वर के करीब लाते हैं!"
      },
      hard: {
        question: "इस सभी प्राप्त ज्ञान के सामने हृदय की सच्ची प्रतिक्रिया क्या है?",
        options: [
          "अब मैं परफेक्ट हूँ",
          "मैं तुम्हें अपना हृदय देता हूँ यीशु और बपतिस्मा लेना चाहता हूँ",
          "मैं दूसरों से बेहतर जानता हूँ",
          "मुझे अब मदद की जरूरत नहीं है"
        ],
        hint: "सच्चा विश्वास पूर्ण समर्पण और यीशु के प्रति प्रतिबद्धता की ओर ले जाता है",
        funFact: "🌟✨ आप पर्वत के शिखर पर पहुँच चुके हैं, और ज्ञान प्राप्त हो चुका है ✨\n\n💖 अटल विश्वास के लिए जीवन का अनुभव, दया और यीशु का सच्चा प्रेम आवश्यक है 💖\n\n🔥 जीवन की विभिन्न परीक्षाएं आपके मार्ग की, सच्चे रास्ते की जिसे हम चुनते हैं, हमारे हृदय की परीक्षा लेंगी 🔥\n\n😔 हम अपूर्ण बने रहते हैं, हमारी इच्छाएं अनेक हैं, और लाभ या हमारे व्यक्तिगत आराम का प्रेम बहुत बार हमारी स्वार्थी प्राथमिकता बन जाता है 😔\n\n🙏 परमेश्वर से ज्ञान, उनका प्रेम, उनकी शक्ति मांगें, और विनम्रता से अपनी कमजोरियों को स्वीकार करें, क्योंकि हम उनसे कुछ भी छिपा नहीं सकते... कुछ भी नहीं 🙏\n\n🥖 दानिय्येल की तरह उपवास करें: कुछ समय के लिए अपने आप को उससे वंचित करें जिसे आप सबसे ज्यादा प्यार करते हैं, शांति और ज्ञान में 🥖\n\n💫 यह आपको परमेश्वर को बेहतर ढंग से सुनने की अनुमति देगा, गहरे परिवर्तनों के लिए तैयार हृदय की स्थिति पाने की 💫\n\n🌙 तब, स्वप्न और दर्शन स्पष्ट हो जाएंगे, जैसे यूसुफ के लिए 🌙\n\n⚠️ घमंड से सावधान रहें: 'मैं हमेशा सही हूँ' या 'मैं बेहतर जानता हूँ' के आगे न झुकें ⚠️\n\n🎁 क्योंकि परमेश्वर का प्रकाशन एक असाधारण अनुग्रह है 🎁\n\n💝 विश्वास रखना एक संबंध और हृदय के मुक्त मार्ग में प्रवेश करना है 💝\n\n🦸‍♂️ यह आपको शक्तिशाली नायक बना देगा, असंभव के लिए सक्षम 🦸‍♂️\n\n✝️ ज्ञान के शिखर पर, ईमानदार हृदय कहता है: 'मैं तुम्हें अपना हृदय देता हूँ यीशु और बपतिस्मा लेना चाहता हूँ' ✝️\n\n🏔️ आप पर्वत के शिखर पर पहुँच चुके हैं, मजबूती से पकड़े रहें, दृढ़ रहें! 🏔️\n\n⬇️ नीचे उतरना होगा और इस अमूल्य खजाने को ले जाना होगा: अनंत जीवन की आशा ⬇️\n\n🏆✨ शाबाश! हम आप पर गर्व करते हैं ✨🏆\n🌟 साहस वीर शांतिदूत 🌟\n🕊️✨ परमेश्वर आपको आशीष दें ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
